<script setup>
import { useRoute } from 'vue-router';

const route = useRoute();
const localCopy = {
  title: 'Central de conexões',
  description:
    'Acesse em um só lugar os canais de atendimento, a biblioteca de IA, as assistentes e as integrações da sua conta.',
};

const cards = [
  {
    title: 'Conexões',
    description:
      'Crie e gerencie as caixas de entrada usadas para falar com seus clientes.',
    icon: 'i-lucide-inbox',
    routeName: 'settings_inbox_list',
    action: 'Gerenciar conexões',
    accent: 'bg-n-blue-3 text-n-blue-11',
  },
  {
    title: 'Biblioteca de IA',
    description:
      'Crie e organize prompts e modelos prontos para padronizar o atendimento.',
    icon: 'i-lucide-library-big',
    routeName: 'talkvia_openai',
    action: 'Abrir biblioteca',
    accent: 'bg-n-amber-3 text-n-amber-11',
  },
  {
    title: 'Assistente IA',
    description:
      'Configure assistentes e conecte cada uma a uma ou mais caixas de entrada.',
    icon: 'i-lucide-bot',
    routeName: 'agent_bots',
    action: 'Gerenciar assistentes',
    accent: 'bg-n-violet-3 text-n-violet-11',
  },
  {
    title: 'Integrações',
    description:
      'Conecte bancos, ERPs, agendas e outros serviços usados na operação.',
    icon: 'i-lucide-plug',
    routeName: 'settings_applications',
    action: 'Gerenciar integrações',
    accent: 'bg-n-teal-3 text-n-teal-11',
  },
];
</script>

<template>
  <div class="flex w-full flex-col gap-6 font-inter">
    <header>
      <h1 class="mb-0 text-2xl font-semibold text-n-slate-12">
        {{ localCopy.title }}
      </h1>
      <p class="mb-0 mt-2 max-w-2xl text-sm leading-6 text-n-slate-11">
        {{ localCopy.description }}
      </p>
    </header>

    <section class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      <router-link
        v-for="card in cards"
        :key="card.routeName"
        :to="{
          name: card.routeName,
          params: { accountId: route.params.accountId },
        }"
        class="group flex min-h-56 flex-col rounded-2xl border border-n-weak bg-n-solid-1 p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-n-brand/50 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-brand"
      >
        <span
          class="grid size-12 place-content-center rounded-xl"
          :class="card.accent"
        >
          <span :class="card.icon" class="size-6" />
        </span>
        <h2 class="mb-0 mt-5 text-lg font-semibold text-n-slate-12">
          {{ card.title }}
        </h2>
        <p class="mb-0 mt-2 flex-1 text-sm leading-6 text-n-slate-11">
          {{ card.description }}
        </p>
        <span
          class="mt-5 flex items-center gap-2 text-sm font-medium text-n-brand"
        >
          {{ card.action }}
          <span
            class="i-lucide-arrow-right size-4 transition-transform group-hover:translate-x-0.5"
          />
        </span>
      </router-link>
    </section>
  </div>
</template>
